// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"9494b0dd","125":"89fa934d","159":"856ca21f","895":"b0bbaa22"}[chunkId] + ".chunk.js";
};